const apiUrl = process.env.NODE_ENV === 'production' ? `${window?.env?.REACT_APP_API_BASEURL}/api/` : 'http://localhost:5000/api/'

export default apiUrl
